import { Routes } from '@angular/router';
import { LayoutComponent } from '../layout/layout.component';
import { AuthGuard } from '../shared/util/auth.guard';
import { Home } from './menu';

export const routes : Routes = [
    {
        path: '',
        //component: LayoutComponent,
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },            
            { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule), component: LayoutComponent, canActivate: [AuthGuard], data: { auth: '1', func: Home.id } },
          //{ path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule), component: LayoutComponent },
            { path: 'login', loadChildren: './login/login.module#LoginModule' },
            { path: 'ketoan', loadChildren: () => import('./ketoan/ketoan.module').then(m => m.KeToanModule), component: LayoutComponent, canActivate: [AuthGuard] },             
            { path: 'danhmuc', loadChildren: () => import('./danhmuc/danhmuc.module').then(m => m.DanhMucModule), component: LayoutComponent, canActivate: [AuthGuard] },
            { path: 'quantri', loadChildren: () => import('./quantri/quantri.module').then(m => m.QuanTriModule), component: LayoutComponent, canActivate: [AuthGuard] },
            { path: 'dutoan', loadChildren: () => import('./dutoan/dutoan.module').then(m => m.DuToanModule), component: LayoutComponent, canActivate: [AuthGuard] },
            { path: 'quyettoan', loadChildren: () => import('./quyettoan/quyettoan.module').then(m => m.QuyetToanModule), component: LayoutComponent, canActivate: [AuthGuard] },  
            { path: 'baocao', loadChildren: () => import('./baocao/baocao.module').then(m => m.BaoCaoModule), component: LayoutComponent, canActivate: [AuthGuard] },
            { path: 'baocaoquyettoan', loadChildren: () => import('./baocaoquyettoan/baocaoquyettoan.module').then(m => m.BaoCaoQuyetToanModule), component: LayoutComponent, canActivate: [AuthGuard] },
            { path: 'baocaodutoan', loadChildren: () => import('./baocaodutoan/baocaodutoan.module').then(m => m.BaoCaoDuToanModule), component: LayoutComponent, canActivate: [AuthGuard] },  
            
        ]
    },  
    // Not found
    { path: '**', redirectTo: 'home' }

];
